module.exports = __webpack_public_path__ + "img/S.f72ed178.jpg";